import React, { useState } from 'react'
import Select from 'react-select'
import { ajaxGet } from '../../../ajax'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'

export default function MemberSelector({openLeague, member, onSelect}) {
  const formattedPhone = user => {
    return user.country_code && user.country_code.toLowerCase() != 'us' ? formatPhoneNumberIntl(user.phone) : formatPhoneNumber(user.phone)
  }

  const loadFacilityPlayers = async (input) => {
    if (!input || input.length < 3) return Promise.resolve({options: []})
    return ajaxGet(`/admins/facility_clients.json?query=${input}&all=true`)
    .then(response => response.json())
    .then(json => {
      return {
        options: json.clients.map(user => {
          const phone = formattedPhone(user)
          const label = [user.name, phone].join(' ')
          
          return {
            value: user.id,
            label: label,
            phone: user.phone,
            country_code: user.country_code,
            name: user.name,
            skill_level: user.skill_level,
            prefer_position: user.prefer_position,
            image: user.image_url
          }
        })
      }
    })
  }

  const loadOpenGamePlayers = async (input) => {
    if (!input || input.length < 3) return Promise.resolve({options: []})
    return ajaxGet(`/admins/clients.json?q=${input}&league=true`)
    .then(response => response.json())
    .then(json => {
      return {
        options: json.users.map(user => {
          return {
            value: user.id,
            label: user.text,
            phone: user.phone,
            country_code: user.country_code,
            name: user.name,
            skill_level: user.skill_level,
            prefer_position: user.prefer_position,
            image: user.image_url
          }
        })
      }
    })
  }

  return <Select.Async
    autoBlur
    placeholder='Select a player'
    searchPromptText='Please enter 3 or more characters'
    value={member}
    onChange={onSelect}
    filterOption={() => true}
    loadOptions={openLeague ? loadOpenGamePlayers : loadFacilityPlayers}
  />
}
